(function () {
  'use strict';

  var PENDING_KEY = 'ever-pretty:partial-checkout:pending:v1';
  var SELECTION_KEY = 'ever-pretty:partial-checkout:selection:v1';
  var restorePromise = null;
  var checkoutBusy = false;

  function rootPath() {
    var configuredRoot = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.rootUrl;
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var root = configuredRoot || shopifyRoot || '/';
    return root.replace(/\/?$/, '/');
  }

  function shopifyUrl(path) {
    return rootPath() + String(path).replace(/^\/+/, '');
  }

  function getStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function removeStorage(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function checkboxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-partial-checkout-checkbox]'));
  }

  function controls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-partial-checkout-controls]'));
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-partial-checkout-button]'));
  }

  function readSelection() {
    try {
      var saved = JSON.parse(getStorage(SELECTION_KEY) || '{}');
      return saved && typeof saved === 'object' ? saved : {};
    } catch (error) {
      return {};
    }
  }

  function saveSelection() {
    var selection = {};
    checkboxes().forEach(function (checkbox) {
      if (!checkbox.checked) selection[checkbox.dataset.lineKey] = false;
    });
    setStorage(SELECTION_KEY, JSON.stringify(selection));
  }

  function applySavedSelection() {
    var saved = readSelection();
    var items = checkboxes();
    var hasSavedItem = items.some(function (checkbox) {
      return Object.prototype.hasOwnProperty.call(saved, checkbox.dataset.lineKey);
    });

    items.forEach(function (checkbox) {
      checkbox.checked = hasSavedItem ? saved[checkbox.dataset.lineKey] !== false : true;
    });
  }

  function formatMoney(cents, withCurrencyCode) {
    var settings = window.themeVariables && window.themeVariables.settings;
    var currency = settings && settings.cartCurrency;
    if (!currency) currency = 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100) + (withCurrencyCode ? ' ' + currency : '');
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + (withCurrencyCode ? ' ' + currency : '');
    }
  }

  function updateSelectionUi() {
    var items = checkboxes();
    var selected = items.filter(function (checkbox) { return checkbox.checked; });
    var allSelected = items.length > 0 && selected.length === items.length;
    var total = selected.reduce(function (sum, checkbox) {
      return sum + Number(checkbox.dataset.lineTotal || 0);
    }, 0);

    controls().forEach(function (control) {
      var selectAll = control.querySelector('[data-partial-checkout-select-all]');
      if (selectAll) {
        selectAll.checked = allSelected;
        selectAll.indeterminate = selected.length > 0 && !allSelected;
      }
      var status = control.querySelector('[data-partial-checkout-status]');
      if (status) {
        status.textContent = selected.length ? selected.length + ' selected' + (allSelected ? '' : ' · Total confirmed at checkout') : 'Select at least one item';
      }
    });

    checkoutButtons().forEach(function (button) {
      button.disabled = selected.length === 0 || checkoutBusy || !!restorePromise;
      button.setAttribute('aria-disabled', String(button.disabled));
    });
    document.querySelectorAll('[data-partial-checkout-total]').forEach(function (totalElement) {
      totalElement.textContent = formatMoney(allSelected ? totalElement.dataset.cartTotal : total, totalElement.hasAttribute('data-partial-checkout-currency-code'));
    });
    document.querySelectorAll('[data-partial-checkout-express]').forEach(function (container) {
      container.hidden = !allSelected || checkoutBusy || !!restorePromise;
    });
  }

  function fingerprint(item) {
    var properties = item.properties || {};
    var normalizedProperties = Object.keys(properties).sort().map(function (key) {
      return [key, String(properties[key])];
    });
    var sellingPlan = item.selling_plan || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || '';
    return [String(item.variant_id || item.id), String(sellingPlan || ''), JSON.stringify(normalizedProperties)].join('|');
  }

  function expandSelectedKeys(cart, selectedKeys) {
    var expanded = new Set(selectedKeys);
    var selectedMains = cart.items.filter(function (item) {
      return expanded.has(item.key) && (!item.properties || item.properties._processing_role !== 'fee');
    });

    cart.items.forEach(function (item) {
      if (!item.properties || item.properties._processing_role !== 'fee') return;
      var linkId = item.properties._processing_link_id;
      if (linkId && selectedMains.some(function (main) {
        return main.properties && main.properties._processing_option === 'rush' && main.properties._processing_link_id === linkId &&
          String(item.properties._processing_for_variant_id) === String(main.variant_id) &&
          String(main.properties._processing_fee_variant_id) === String(item.variant_id);
      })) {
        expanded.add(item.key);
      }
    });
    return expanded;
  }

  function pendingItem(item) {
    var sellingPlan = item.selling_plan || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id);
    var payload = {
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {}
    };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    return payload;
  }

  function notify(message) {
    controls().forEach(function (control) {
      var status = control.querySelector('[data-partial-checkout-status]');
      if (status) {
        status.textContent = message;
        status.setAttribute('role', 'alert');
      }
    });
  }

  function setBusy(isBusy) {
    checkoutBusy = isBusy;
    updateSelectionUi();
    checkoutButtons().forEach(function (button) {
      button.setAttribute('aria-busy', String(isBusy));
    });
  }

  async function fetchCart() {
    var response = await fetch(shopifyUrl('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to read your cart. Please refresh and try again.');
    return response.json();
  }

  async function partialCheckout(form) {
    var cart = await fetchCart();
    var renderedKeys = new Set(checkboxes().map(function (checkbox) { return checkbox.dataset.lineKey; }));
    var selectedKeys = new Set(checkboxes().filter(function (checkbox) { return checkbox.checked; }).map(function (checkbox) { return checkbox.dataset.lineKey; }));
    if (cart.items.some(function (item) {
      return (!item.properties || item.properties._processing_role !== 'fee') && !renderedKeys.has(item.key);
    }) || Array.from(renderedKeys).some(function (key) {
      return !cart.items.some(function (item) { return item.key === key; });
    })) {
      throw new Error('Your cart changed. Please refresh and select your items again.');
    }
    var selectedCartKeys = expandSelectedKeys(cart, selectedKeys);
    var unselectedItems = cart.items.filter(function (item) { return !selectedCartKeys.has(item.key); });

    if (!unselectedItems.length) {
      delete form.dataset.partialCheckoutBusy;
      form.dataset.partialCheckoutPassed = 'true';
      setBusy(false);
      form.requestSubmit();
      return;
    }

    if (getStorage(PENDING_KEY)) {
      throw new Error('Some saved cart items still need to be restored. Please refresh your cart before checking out selected items.');
    }
    var pendingSaved = setStorage(PENDING_KEY, JSON.stringify({
      createdAt: Date.now(),
      items: unselectedItems.map(pendingItem)
    }));
    if (!pendingSaved) {
      throw new Error('Your browser could not save the items for later. Please enable browser storage or select all items.');
    }

    var updates = {};
    cart.items.forEach(function (item) {
      updates[item.key] = selectedCartKeys.has(item.key) ? item.quantity : 0;
    });

    var response = await fetch(shopifyUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Your cart could not be prepared for checkout. Please try again.');
    window.location.assign(shopifyUrl('checkout'));
  }

  async function restorePendingItems() {
    if (location.pathname.indexOf('/checkout') !== -1 || restorePromise) return restorePromise;
    var raw = getStorage(PENDING_KEY);
    if (!raw) return null;

    restorePromise = (async function () {
      var pending;
      try {
        pending = JSON.parse(raw);
      } catch (error) {
        removeStorage(PENDING_KEY);
        return null;
      }
      if (!pending || !Array.isArray(pending.items) || !pending.items.length) {
        removeStorage(PENDING_KEY);
        return null;
      }

      var cart = await fetchCart();
      var existing = new Set(cart.items.map(fingerprint));
      var items = pending.items.filter(function (item) { return !existing.has(fingerprint(item)); });
      if (items.length) {
        var response = await fetch(shopifyUrl('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error('Some saved cart items could not be restored.');
      }
      removeStorage(PENDING_KEY);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
      }
      return true;
    })().finally(function () {
      restorePromise = null;
      updateSelectionUi();
    }).catch(function (error) {
      notify(error.message);
      return false;
    });
    return restorePromise;
  }

  function handleChange(event) {
    var target = event.target;
    if (target.matches('[data-partial-checkout-checkbox]')) {
      checkboxes().forEach(function (checkbox) {
        if (checkbox.dataset.lineKey === target.dataset.lineKey) checkbox.checked = target.checked;
      });
      saveSelection();
      updateSelectionUi();
      return;
    }
    if (target.matches('[data-partial-checkout-select-all]')) {
      checkboxes().forEach(function (checkbox) { checkbox.checked = target.checked; });
      saveSelection();
      updateSelectionUi();
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;
    if (restorePromise || checkoutBusy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (form.dataset.partialCheckoutPassed === 'true') {
      delete form.dataset.partialCheckoutPassed;
      return;
    }
    var items = checkboxes();
    if (!items.length || items.every(function (checkbox) { return checkbox.checked; })) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.partialCheckoutBusy === 'true') return;
    if (!items.some(function (checkbox) { return checkbox.checked; })) {
      notify('Select at least one item to checkout.');
      updateSelectionUi();
      return;
    }

    form.dataset.partialCheckoutBusy = 'true';
    setBusy(true);
    partialCheckout(form).catch(function (error) {
      delete form.dataset.partialCheckoutBusy;
      setBusy(false);
      notify(error.message);
    });
  }

  function boot() {
    applySavedSelection();
    updateSelectionUi();
    document.addEventListener('change', handleChange, true);
    document.addEventListener('submit', handleSubmit, true);
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-partial-checkout-controls], [data-partial-checkout-checkbox]') || node.querySelector('[data-partial-checkout-controls], [data-partial-checkout-checkbox]'));
        });
      })) {
        applySavedSelection();
        updateSelectionUi();
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () {
      applySavedSelection();
      updateSelectionUi();
    });
    restorePendingItems();
    updateSelectionUi();
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      checkoutBusy = false;
      document.querySelectorAll('[data-partial-checkout-busy]').forEach(function (form) {
        delete form.dataset.partialCheckoutBusy;
      });
      restorePendingItems();
      updateSelectionUi();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
